import React, { useEffect, useState } from 'react';
import "./NotificationsList.scss"

import { useFetching } from '../../../hooks/useFetching';
import PostService from '../../../API/PostService';
import NotificationsItem from '../NotificationsItem/NotificationsItem';
import { useSelector } from 'react-redux';

import { useHorizontalScroll } from '../../../hooks/useHorizontalScroll';

const NotificationsList = () => {
	const scrollRef = useHorizontalScroll();
	const unreadCount = useSelector(state => state.notifications.unreadCount)
	const clinic = useSelector(state => state.recordsTable.clinic)
	const currentUser = useSelector(state => state.currentUser.currentUser)
	const [ counter, setCounter ] = useState(0);

	const [ list, setList ] = useState([]);
	const [ listDefault, setListDefault ] = useState([]);
	const [ filterType, setFilterType ] = useState('all');

	useEffect(() => {
		if(clinic && currentUser) fetchUserNotifications(clinic, currentUser.id);
	}, [clinic, currentUser]);

	const [fetchUserNotifications] = useFetching(async (clinicId, userId) => {
		const response = await PostService.getUserNotifications(clinicId, userId)
		if (response.data.success && response.data.result !== false) {
			setListDefault(response.data.result)
			setList(response.data.result)
		}
	})

	const filterByType = ( type ) => {
		setFilterType(type)
		switch (type) {
			case 'all':
				setList(listDefault)
				break;
			case 'unread':
				setList(listDefault.filter((el) => el.read !== '1'))
				break;
			case 'read':
				setList(listDefault.filter((el) => el.read === '1'))
				break;
			case 'confirmed':
				console.log(listDefault.filter((el) => el.record?.status?.id === '3'))
				setList(listDefault.filter((el) => el.record?.status?.id === '3'))
				break;
			case 'not-confirmed':
				setList(listDefault.filter((el) => el.record?.status?.id === '2'))
				break;

			default:
				break;
		}
	}

	useEffect(() => {
		if(unreadCount && Number(unreadCount) > 0){
			setCounter(Number(unreadCount))
		}
	}, [unreadCount])

	return (
		<div className="notifications-list">
			<div className="notifications-list__headline">
				<h3>События</h3>
				{
					counter > 0 &&
					<span>{counter}</span>
				}
			</div>
			<div ref={scrollRef} className="notifications-list__filter g-hide-scrollbar">
				<div className="notifications-list__filter-holder">
					<button className={'notifications-list__filter-btn' + (filterType === 'all' ? ' active' : '')}
						onClick={() => filterByType('all')}>Все</button>
					<button className={'notifications-list__filter-btn' + (filterType === 'unread' ? ' active' : '')}
						onClick={() => filterByType('unread')}>Непрочитано</button>
					<button className={'notifications-list__filter-btn' + (filterType === 'read' ? ' active' : '')}
						onClick={() => filterByType('read')}>Прочитано</button>
					<button className={'notifications-list__filter-btn' + (filterType === 'confirmed' ? ' active' : '')}
						onClick={() => filterByType('confirmed')}>Подтвержденные</button>
					<button className={'notifications-list__filter-btn' + (filterType === 'not-confirmed' ? ' active' : '')}
						onClick={() => filterByType('not-confirmed')}>Не подтвержденные</button>
				</div>
			</div>
			<div className="notifications-list__content g-hide-scrollbar">
				{list && list.map((notif) => {
					return(
						<NotificationsItem element={notif} key={notif.id}/>
					)
				})}
			</div>
		</div>
	);
};

export default NotificationsList;
